(function(){
  // Desktop-view detection for the PDP scroll-pin gallery.
  //
  // WHY THIS EXISTS (2026-08-02): width-based detection (matchMedia) is unreliable when Chrome's
  // "Request Desktop Site" is forced on a phone — confirmed via debug readout that
  // window.innerWidth (1450) and CSS media query evaluation (min-width:980px was FALSE) disagree
  // with each other on the same page load. That's a browser-level inconsistency, not something
  // fixable by picking a different breakpoint number.
  //
  // FIX: an explicit, sticky override that doesn't depend on measuring the viewport at all.
  // Visit any page once with ?desktop=1 in the URL and it's remembered for 30 days (works even
  // if you always browse in forced-desktop-site mode). ?desktop=0 clears it. With no override
  // set, falls back to the normal matchMedia check for everyone else (real desktop browsers,
  // where this problem doesn't occur).
  function getParam(name){
    var m = new RegExp('[?&]' + name + '=([^&]+)').exec(location.search);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getCookie(name){
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days){
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + '; expires=' + d.toUTCString() + '; path=/';
  }

  var param = getParam('desktop');
  if(param === '1'){ setCookie('ad_force_desktop', '1', 30); }
  if(param === '0'){ setCookie('ad_force_desktop', '0', 30); }

  function apply(){
    var forced = getCookie('ad_force_desktop');
    var isDesktop;
    if(forced === '1'){
      isDesktop = true;
    } else if(forced === '0'){
      isDesktop = false;
    } else {
      isDesktop = window.matchMedia('(min-width: 980px)').matches;
    }
    document.documentElement.classList.toggle('ad-scroll-desktop', isDesktop);
  }

  apply();

  // Only listen for live viewport changes when there's no explicit override — an override
  // should stay locked regardless of what the browser reports the width as.
  if(getCookie('ad_force_desktop') === null){
    var mq = window.matchMedia('(min-width: 980px)');
    if(mq.addEventListener){ mq.addEventListener('change', apply); }
    else if(mq.addListener){ mq.addListener(apply); }
  }
})();
